module.exports = __webpack_public_path__ + "img/samoa.1570ea5.webp";